import React from "react";
import { Col, Flex, Layout, Row } from "antd";
import css from "./Footer.module.css";
import { QuestionCircleFilled } from '@ant-design/icons';
const { Footer: AntFooter } = Layout;

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <AntFooter className={css.footer}>
      <Flex vertical={false} align="center" justify="space-between" className={css.footerInner}>
        <Row className={css.rowLeft}>
          <Col>
            <a href="https://babelops.notion.site/1acd27bba73e80b692e2e9bb9a2b9e1a?v=1acd27bba73e81989dd1000c08105fa7&pvs=4" target="_blank" className={css.help}>Help Articles <QuestionCircleFilled /></a>
          </Col>
          <Col className={css.copy}>Copyright ©️ {year}</Col>
        </Row>
        <Row gutter={16} className={css.rowRight}>
          <Col className={css.col}>TERMS</Col>
          <Col className={css.col}>PRIVACY</Col>
          <Col className={css.col}>DO NOT SELL MY PERSONAL INFORMATION</Col>
        </Row>
      </Flex>
    </AntFooter>
  );
};
